import { Inject, Injectable } from '@angular/core';

import { CommunityTransactionForSaleQuery, FillDocumentItemResult, SaleCommunityTransactionSymbol, VatRateForSaleQuery, ViewSettingsRepositoryBase } from '@skylab-shared/business';
import { RootContextBase } from '@skylab-shared/core';

import { ViewSettingsRepository } from '@skylab-angular-shared/business';
import { RootContext } from '@skylab-angular-shared/core';
import { DialogInsService } from '@skylab-angular-shared/ui';
import { DocumentItemVatRateNotAvailableDialogComponent, DocumentItemVatRateNotAvailableDialogData } from './dialog/document-item-vat-rate-not-available-dialog.component';


@Injectable({ providedIn: 'root' })
export class DocumentItemVatRateNotAvailableService {
    public constructor (
        @Inject(RootContext) private readonly rootContext: RootContextBase,
        @Inject(ViewSettingsRepository) private readonly viewSettingsRepository: ViewSettingsRepositoryBase,
        private readonly dialogService: DialogInsService
    ) { }

    public async handleAsync(data: FillDocumentItemResult, communityTransactionId: number): Promise<void> {
        const vatRates = await this.rootContext.getAsync(VatRateForSaleQuery);
        const availableVatRates = vatRates.filter(v => v.communityTransactions.includes(communityTransactionId));
        if (data.vatRateId.previous && !availableVatRates.find(vatRate => vatRate.id === data.vatRateId.previous)) {
            const communityTx = await this.rootContext.firstAsync(CommunityTransactionForSaleQuery, { id: communityTransactionId });
            if (!communityTx) return;
            const communityTransaction = communityTx.symbol;

            const oldVatRateItem = vatRates.find(elm => elm.id === data.vatRateId.previous);
            if (!oldVatRateItem) return;
            const oldVatRate = oldVatRateItem.symbol;
            let saleVatRateAvailableConfig: boolean | Record<SaleCommunityTransactionSymbol, boolean>;
            if (communityTransaction === 'WSTO-OSS') {
                if (data.vatRateId.wstoVatRateOnProduct) return;

                saleVatRateAvailableConfig = await this.viewSettingsRepository.getViewSettingsAsync<boolean>('sale-oss-vat-rate-not-available-dont-show-again');
                if (saleVatRateAvailableConfig) return;
            } else {
                saleVatRateAvailableConfig = await this.viewSettingsRepository.getViewSettingsAsync<Record<SaleCommunityTransactionSymbol, boolean>>('sale-vat-rate-not-available-dont-show-again');
                if (saleVatRateAvailableConfig?.[communityTransaction]) return;
            }

            await this.dialogService.showAsync<{data: DocumentItemVatRateNotAvailableDialogData}, void>({
                component: DocumentItemVatRateNotAvailableDialogComponent, componentProps: {
                    data: { oldVatRate, communityTransaction, vatRatesAvailableConfig: saleVatRateAvailableConfig }
                }
            });
        }
    }
}
